import { render, staticRenderFns } from "./TractSettings.vue?vue&type=template&id=4aefdd96&"
import script from "./TractSettings.vue?vue&type=script&lang=js&"
export * from "./TractSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports